import { Md5 } from "ts-md5";
import type { AIEquipmentSuggestionsRequest } from "@/libs/api/aiEquipmentSuggestions";

function canonical(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).sort(([a], [b]) =>
      a.localeCompare(b)
    ).map(([key, item]) => [key, canonical(item)]));
  }
  return value;
}

export function recommendationCacheKey(
  request: AIEquipmentSuggestionsRequest,
  inputIdentity?: unknown
): string {
  // All three priorities are returned together; changing tabs isn't a rerun.
  const { optimizationPriority: _priority, ...inputs } = request;
  return Md5.hashStr(JSON.stringify(canonical({ inputs, inputIdentity })));
}
